const CC = require('CC');
class Action {
    constructor(options) {
        this.config = {
            icon: '',
            title: '',
            isUnderMore: false,
            isEnabled: true,
            isVisible: true,
            ccEventName: '',
            url: null,
            disabledTitle: '',
            rowClass: '',
            ...options
        };
    }
}

export class ActionBuilder {
    constructor({ eventPrefix = '', maxVisibleCount = 2 } = {}) {
        this.actions = [];
        this.eventPrefix = eventPrefix;
        this.position = 0;
        this.maxVisibleCount = maxVisibleCount;
    }

    contextualAction(name, options) {
        return this.custom(name, {
            title: model => {
                const state = CC.utils.getResult(options, 'currentState', {}, model);
                return options.states[state].title;
            },
            icon: model => {
                const state = CC.utils.getResult(options, 'currentState', {}, model);
                return options.states[state].icon;
            },
            class: model => {
                const state = CC.utils.getResult(options, 'currentState', {}, model);
                return options.states[state].class;
            },
            isEnabled: options.isEnabled,
            eventFn: (model, isEnabled, event) => {
                const state = CC.utils.getResult(options, 'currentState', {}, model);
                return options.states[state].eventFn(model, isEnabled, event);
            }
        });
    }

    copy(options = {}) {
        return this.custom('copy', {
            icon: 'lotacon lotacon-file-copy-line',
            title: 'Copy',
            ...options
        });
    }

    custom(type, options) {
        this.position++;
        this.actions.push(
            new Action({
                ccEventName: `${this.eventPrefix}:${type}`,
                isUnderMore: this.position > this.maxVisibleCount,
                ...options
            })
        );
        return this;
    }

    delete(options = {}) {
        return this.custom('delete', {
            icon: 'lotacon lotacon-delete-bin-line',
            rowClass: 'bg--destructive',
            title: 'Delete',
            ...options
        });
    }

    edit(options = {}) {
        return this.custom('edit', {
            icon: 'lotacon lotacon-pencil-line',
            title: 'Edit',
            ...options
        });
    }

    history(options = {}) {
        return this.custom('history', {
            icon: 'lotacon lotacon-history-line',
            title: 'History',
            ...options
        });
    }

    info(options = {}) {
        return this.custom('info', {
            icon: 'lotacon lotacon-circle-info',
            title: 'Info',
            ...options
        });
    }

    stats(options = {}) {
        return this.custom('stats', {
            icon: 'lotacon lotacon-bar-chart-line',
            title: 'Stats',
            ...options
        });
    }

    build(model) {
        return this.actions.map(action => action.config);
    }
}
